import moment from 'moment';
import { priceConverter } from 'helpers';

export type AreaConfigData = { day: string; value: number };

export type TransactionsSerialized = {
  serializedTransactionsStats: {
    numberOfTransactionsInDay: number;
    respectivedate: Date;
    amount: number;
  }[];
  totalTransactions: number;
  totalAmount: number;
};

export type statPoint = {
  date: string;
  count: number;
  sum: number;
  transactionIds: number[];
};

export type underContractStats = {
  total: statPoint;
  listings: statPoint;
  purchases: statPoint;
};

export type expiringStats = {
  dueToday: statPoint;
  dueThisWeek: statPoint;
  dueThisMonth: statPoint;
};

export type closedStats = {
  MTD: statPoint;
  QTD: statPoint;
  YTD: statPoint;
};

export type clientStats = {
  date: string;
  Active: number;
  Retention: number;
};

export const setStats = (currentStats, value, setTotalAmount, setTotalRequests?) => {
  if (!currentStats) return;
  const latestStat = currentStats[value];

  setTotalAmount(priceConverter(latestStat?.sum || 0, 2));
  setTotalRequests?.(latestStat?.count || 0);
};
